import { useState, useEffect, createContext, useContext, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SiteSettingsContext = createContext(null);

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchSettings = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/settings`);
      setSettings(response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching site settings:', error);
      // Use defaults if API fails
      const defaults = {
        brand_name: "Lou's Way",
        primary_color: "#BFA05F",
        secondary_color: "#1A1815",
        accent_color: "#D4AF37",
        background_color: "#F9F8F6",
        text_color: "#1A1815",
        button_bg_color: "#1A1815",
        button_text_color: "#FFFFFF",
        button_hover_bg_color: "#BFA05F",
        button_hover_text_color: "#FFFFFF",
        address: "Galerias De Torres Loja 11B, Av. Gen. Humberto Delgado 32, 2560-272, Torres Vedras, Portugal",
        phone: "+351 915 534 864",
        email: "lourdyane.rod@gmail.com",
        instagram: "https://instagram.com/lousway",
        facebook: "https://facebook.com/lousway",
        business_hours_pt: "Seg-Sáb: 9h - 19h",
        business_hours_en: "Mon-Sat: 9am - 7pm",
        hero_title_pt: "Beleza",
        hero_title_accent_pt: "Real",
        hero_subtitle_pt: "Experiencie tratamentos de estética exclusivos num ambiente de luxo e conforto.",
        hero_title_en: "Beauty that",
        hero_title_accent_en: "Transforms",
        hero_subtitle_en: "Experience exclusive aesthetic treatments in a luxurious and comfortable environment.",
        btn_book_pt: "Agendar Consulta",
        btn_book_en: "Book Appointment",
        btn_discover_pt: "Descobrir Serviços",
        btn_discover_en: "Discover Services",
        about_title_pt: "Nossa História",
        about_title_en: "Our Story",
        about_text_pt: "O Lou's Way nasceu do sonho de criar um espaço onde a beleza encontra o bem-estar.",
        about_text_en: "Lou's Way was born from the dream of creating a space where beauty meets wellness.",
        footer_text_pt: "Todos os direitos reservados.",
        footer_text_en: "All rights reserved.",
      };
      setSettings(defaults);
      return defaults;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  // Função para atualizar as settings localmente e no servidor
  const updateSettings = useCallback(async (newSettings) => {
    try {
      await axios.put(`${API}/settings`, newSettings, { withCredentials: true });
      setSettings(newSettings);
      return true;
    } catch (error) {
      console.error('Error updating settings:', error);
      return false;
    }
  }, []);

  // Helper para obter URL completo das imagens
  const getImageUrl = useCallback((path) => {
    if (!path) return null;
    if (path.startsWith('http')) return path;
    return `${process.env.REACT_APP_BACKEND_URL}${path}`;
  }, []);

  return (
    <SiteSettingsContext.Provider value={{ settings, loading, refetch: fetchSettings, updateSettings, getImageUrl }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => {
  const context = useContext(SiteSettingsContext);
  if (!context) {
    throw new Error('useSiteSettings must be used within SiteSettingsProvider');
  }
  return context;
};
